export default "__VITE_ASSET__Bei2uLBc__"